import { ApiAccess } from 'features/session/types'
import { CancelToken } from 'axios'
import { ApiGetFileWithToken } from 'shared/api'
import { avatarApi } from 'interface/endpoints'

// 1日単位でのcacheTime
const t = Math.floor(new Date().getTime() / 86400000)

const GetAvatar = (
  apiAccess: ApiAccess,
  kojinCode: string | null | undefined,
  cancelToken?: CancelToken
) => ApiGetFileWithToken(
	apiAccess,
	kojinCode ? avatarApi(`/kojin/${kojinCode}`, { t }) :
	avatarApi('/unknown', { t }),
	cancelToken
)

export const GetAvatarImage = async (
  apiAccess: ApiAccess,
  kojinCode: string | null | undefined,
  cancelToken?: CancelToken
) => {
  try {
    const avator = await GetAvatar(apiAccess, kojinCode, cancelToken)
    const toBase64 = (blob: Blob) =>
      new Promise<string>((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onload = () => resolve(reader.result as string)
        reader.onerror = reject
      })
    if (!avator) return `${process.env.PUBLIC_URL}/avatar/unknown.png`
    return await toBase64(avator.blob)
  } catch {
    return `${process.env.PUBLIC_URL}/avatar/unknown.png`
  }
}
